import { render } from "./MainCustom.vue?vue&type=template&id=571d9135&scoped=true"
import script from "./MainCustom.vue?vue&type=script&lang=js"
export * from "./MainCustom.vue?vue&type=script&lang=js"

import "./MainCustom.vue?vue&type=style&index=0&id=571d9135&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571d9135"]])

export default __exports__